<template>
  <div class="page-header">
    <div class=" columns is-vcentered">
      <div class="column is-4 column-left">
        <slot name="left">
          <app-breadcrumbs></app-breadcrumbs>
        </slot>
      </div>
      <div class="column is-4 column-center">
        <slot name="center">
          <div class="page-header-title">
            {{ currentTitle }}
          </div>
        </slot>
      </div>
      <div class="column is-4 column-right">
        <slot name="right"> </slot>
        <button v-if="hasCreate" class="button" @click="$emit('click:create')">
          <span class="icon-add"></span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import AppBreadcrumbs from '@/components/AppBreadcrumbs';
import _ from 'lodash';

export default {
  name: 'PageHeader',
  components: { AppBreadcrumbs },
  props: {
    hasCreate: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    currentTitle() {
      return (
        this.title ||
        _.chain(this.$route.matched)
          .last()
          .get('meta.title', 'Error')
          .value()
      );
    }
  }
};
</script>

<style lang="scss">
.page-header {
  padding-bottom: $block-spacing * 2 !important;
  margin-bottom: $block-spacing * 2 !important;
  .column-left,
  .column-right,
  .column-center {
    display: flex;
    align-items: center;
  }
  .column-center {
    justify-content: center;
  }
  .column-right {
    justify-content: flex-end;
  }

  .page-header-title {
    font-size: 2.2rem;
    font-weight: bold;
    max-width: 270px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}
</style>
